import StripePaymentForm from "../../../../../../Shared/StripePayment/StripePaymentForm";
import StripeDetailsView from "../../../../../../Shared/StripePayment/StripeDetailsView";
import RecaptchaNotice from "../../../../../../Shared/RecaptchaNotice";
import { ControlledCheckbox, palette, Typography } from "@powerdiary/components-library/lib";
import { amountToCurrency } from "../../../../../../../utils/localeHelper";
import { selectBooking } from "../../../../../bookingSlice";
import { CreditCardInfo } from "../../../../../../../types/generated/models";
import { useClientPortalConfigContext } from "../../../../../../../context/ClientPortalConfig.ctx";
import { useClientPortalSelector } from "../../../../../../../redux";

interface PaymentFormProps {
    paymentRequired: boolean;
    optionalPaymentEnabled: boolean;
    editCardMode: boolean;
    creditCardInfo: CreditCardInfo;
    setEditCardMode: (mode: boolean) => void;
    totalFee: number;
}
export default function PaymentForm({
    paymentRequired,

    optionalPaymentEnabled,
    editCardMode,
    creditCardInfo,
    setEditCardMode,
    totalFee,
}: PaymentFormProps) {
    const {
        clientPortalConfig: { currencySymbol, isStripeFeeEnabled },
    } = useClientPortalConfigContext();

    const booking = useClientPortalSelector(selectBooking);
    const service = booking?.service;
    return (
        (paymentRequired || optionalPaymentEnabled || service?.data?.needsDeposit) && (
            <>
                {editCardMode ? (
                    <StripePaymentForm />
                ) : (
                    <StripeDetailsView creditCardInfo={creditCardInfo} setEditCardMode={setEditCardMode} />
                )}

                <ControlledCheckbox
                    label="Save this card for future charges"
                    name="storeCard"
                    dataTestIdSuffix="store_card"
                />

                {isStripeFeeEnabled && (
                    <Typography
                        variant="paragraphSmallRegular"
                        marginLeft="1px"
                        color={palette.neutral["700"]}
                        data-test-id="text_card_processing_fee"
                    >
                        {`Card processing fee of ${amountToCurrency(totalFee, currencySymbol)} applies`}
                    </Typography>
                )}

                <RecaptchaNotice />
            </>
        )
    );
}
